module.exports = __webpack_public_path__ + "img/date.00dbf2a.jpg";